<template>
  <v-list-tile-avatar :color="stroll.marker_colour">
    <v-icon color="white" v-text="stroll.marker_icon" />
  </v-list-tile-avatar>
</template>

<script>
export default {
  name: 'StrollAvatar',

  props: {
    stroll: Object,
  },
}
</script>
